module.exports = {"title":"TradFood","completeTitle":"Trad'Food - Manger et cuisiner traditionnel à Bordeaux"}


//////////////////
// WEBPACK FOOTER
// ./src/meta.json
// module id = 51
// module chunks = 1